import type { GetServerSideProps, NextPage } from "next";
import Head from "next/head";
import { Suspense } from "react";
import dynamic from "next/dynamic";
import HomeController from "../../controller/precon/preconhome.controller";
const Header = dynamic(() => import("../../Layout/Preconstruction/Header"), {
  suspense: true,
});
const RecentProjects = dynamic(
  () => import("../../Layout/Preconstruction/RecentProjects")
);

const SEO = dynamic(() => import("../../Layout/Preconstruction/SEO"));
const Home: NextPage = (props: any) => {
  return (
    <div>
      <Head>
        <title>New Bungalows For Sale in Ontario visit Bungalow Finder</title>
        <meta
          name="title"
          property="og:title"
          content="New Bungalows For Sale in Ontario visit Bungalow Finder"
        />
        <meta
          name="description"
          property="og:description"
          content="latest new bungalow developments in Ontario. search bungalows for sale in Toronto province. Find home with Bungalow Finder's new bungalows listings. "
        />
        <meta
          name="keywords"
          content="bungalows for sale,bungalows for sale toronto,bungalows for sale in ontario,new bungalow developments near me,new bungalows for sale,new construction homes, newly built properties, modern designs, high-quality features, new construction developments, find a new home, Bungalow Finder"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://bungalowfinder.ca/newconstruction`}
        />
        <meta
          property="og:image"
          content="https://bungalowfinder.ca/bungalow-color-logo.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Bungalows for Sale in Ontario visit Bungalow Finder"
        />
      </Head>

      <main className="bg-gray-100">
        <Suspense
          fallback={
            <>
              <p>Loading ...</p>
            </>
          }
        >
          <Header />
        </Suspense>{" "}
        <div>
          <Suspense
            fallback={
              <>
                <p>Loading ...</p>
              </>
            }
          >
            <RecentProjects query={props.query} data={props.recents} />
          </Suspense>{" "}
          <SEO />
        </div>
      </main>
    </div>
  );
};

export default Home;
export const getServerSideProps: GetServerSideProps = async (context) => {
  return await HomeController(context);
};
